import { Component } from '@angular/core';

@Component({
    selector: 'app-oauth-component',
    templateUrl: './oauth-component.html',
    standalone: false
})
export class OauthComponent {

}
